export default __webpack_public_path__ + "static/2.2_IT-aa51463254f8f4d81852ff6fdf3c4182.webp";